
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://xperformancedigital.com.br/wp-content/uploads/2025/10/logo-branca.png" 
              alt="See Media - Mídia Inteligente" 
              className="h-12 w-auto object-contain max-w-none"
              style={{ minWidth: '120px' }}
              onError={(e) => {
                console.log('Erro ao carregar logo:', e);
                e.currentTarget.style.display = 'none';
              }}
              onLoad={() => console.log('Logo carregado com sucesso')}
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Sobre
            </button>
            <button 
              onClick={() => scrollToSection('tecnologia')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Tecnologia
            </button>
            <button 
              onClick={() => scrollToSection('mercados')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Mercados
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Contato
            </button>
          </nav>

          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('contato')}
              variant="primary"
              size="sm"
            >
              Fale Conosco
            </Button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white w-6 h-6 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4 mt-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('tecnologia')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Tecnologia
              </button>
              <button 
                onClick={() => scrollToSection('mercados')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Mercados
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Contato
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}